import { z } from 'zod';
import {
  ApiPath,
  meResponseSchema,
  periodeHonorSchema,
  slipHonorariumSchema,
  riwayatAbsensiResponseSchema,
  type ChangePasswordRequest,
  type UpdateMeRequest,
} from '@app/shared';
import { apiGet, apiPatch, apiPost, apiList } from '../../lib/api';

const nullSchema = z.null();

export const getMyProfile = () => apiGet(ApiPath.AUTH.ME, meResponseSchema);
export const updateMyProfile = (body: UpdateMeRequest) =>
  apiPatch(ApiPath.AUTH.UPDATE_ME, body, nullSchema);
export const changeMyPassword = (body: ChangePasswordRequest) =>
  apiPost(ApiPath.AUTH.CHANGE_PASSWORD, body, nullSchema);

// --- Self-service slip honorarium (M6) ---

export const getMySlip = (periodeId: number) =>
  apiGet(ApiPath.HONORARIUM.SLIP_SAYA, slipHonorariumSchema, { periode_id: periodeId });

// --- Self-service periode honor list (M6) ---

export const getMyPeriodeHonorList = (params?: {
  page?: number;
  limit?: number;
  search?: string;
  status?: 'draft' | 'diproses' | 'terkunci';
}) => apiList(ApiPath.HONORARIUM.PERIODE, periodeHonorSchema, params);

// --- Self-service riwayat absensi (M6) ---

export const getMyRiwayatAbsensi = (params?: {
  page?: number;
  limit?: number;
  periodeId?: number;
  status?: 'hadir' | 'izin' | 'sakit' | 'alpha';
}) => apiGet(ApiPath.ABSENSI.RIWAYAT, riwayatAbsensiResponseSchema, params);
